import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getNewPaginationUriRef } from '../../utils/uriUtils';
import styles from './SbSharedPagination.scss';
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';

const SbSharedPaginationItem = ({ index, uriRef, isLast, isSelected, onClick }) => {
    let paginationItem;
    const newUriRef = getNewPaginationUriRef(uriRef, index);
    const paginationItemClasses = classnames(styles.paginationItem, {
        [styles.isLast]: isLast,
    });
    if (isSelected) {
        paginationItem = <span className={styles.isCurrent}>{index}</span>;
    } else {
        paginationItem = (
            <SbSharedLink
                href={newUriRef}
                className={styles.paginationLink}
                onClick={onClick}
                dataTn={`page-${index}`}
            >
                {index}
            </SbSharedLink>
        );
    }

    return <li className={paginationItemClasses}>{paginationItem}</li>;
};

SbSharedPaginationItem.defaultProps = {
    onClick: () => {},
};

SbSharedPaginationItem.propTypes = {
    index: PropTypes.number.isRequired,
    uriRef: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    isLast: PropTypes.bool,
    isSelected: PropTypes.bool,
};

export { SbSharedPaginationItem };
